import { render, staticRenderFns } from "./xjxjDetail.vue?vue&type=template&id=24be6626&scoped=true&"
import script from "./xjxjDetail.vue?vue&type=script&lang=js&"
export * from "./xjxjDetail.vue?vue&type=script&lang=js&"
import style0 from "./xjxjDetail.vue?vue&type=style&index=0&id=24be6626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24be6626",
  null
  
)

export default component.exports